import { gql } from '@apollo/client';

const MUTATION_MOVE_ASSETS = gql`
  mutation MoveAssets($assetIds: [ID!]!, $destinationId: ID!) {
    moveAssets(input: { assetIds: $assetIds, destinationId: $destinationId }) {
      assets {
        ... on AssetFeedItem {
          id
          projectInfo {
            id
            databaseId
            formattedLine1
            formattedLine2
          }
        }
      }
      errors {
        message
        path
        error
      }
    }
  }
`;

export default MUTATION_MOVE_ASSETS;
